import * as React from 'react';
import * as style from './CompilationHeaderLayout.css';

export interface ICompilationHeaderLayoutProps {
  title: React.ReactNode;
  description: React.ReactNode;
  ref?: React.Ref<HTMLDivElement>;
}

export const CompilationHeaderLayout: React.FC<ICompilationHeaderLayoutProps> = ({ title, description, ref }) => {
  return (
    <div className={style['container']} ref={ref}>
      {title}
      {description}
    </div>
  );
};
